import { render, staticRenderFns } from "./coins.vue?vue&type=template&id=0b0c6aaa&scoped=true"
import script from "./coins.vue?vue&type=script&lang=js"
export * from "./coins.vue?vue&type=script&lang=js"
import style0 from "./coins.vue?vue&type=style&index=0&id=0b0c6aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c6aaa",
  null
  
)

export default component.exports